import type { Router } from "vue-router";

export type SQDCTileNavigationDestination = "kpi-board" | "board-settings";

export async function navigateToSQDCTile(
  router: Router,
  boardId: number,
  tileId: number,
  destination: SQDCTileNavigationDestination = "kpi-board",
) {
  await router.push({
    name: destination === "board-settings" ? "boardManagement" : "KPIBoardNew",
    params: { boardId },
    query: { tile: String(tileId) },
  });
}
